/**
 *  Keywords mutations module file
**/

import { MUTATIONS } from './constants'

export const mutations = {
  [MUTATIONS.SET_SELECTED]: (state, { key, flag }) => {
    state.selectedMap = { ...state.selectedMap, [key]: flag }
  },
  [MUTATIONS.SET_CHILDREN]: (state, { key, children }) => {
    state.childrenMap = { ...state.childrenMap, [key]: children }
  },
  [MUTATIONS.RESET_TREE]: (state) => {
    state.childrenMap = {}
    state.selectedMap = {}
  }
}
